module.exports = __webpack_public_path__ + "assets/8dcab40314adc67f4fda42d778be82bd.mp3";